import React from 'react';

function TableCell({
                       content,
                       containerStyle,
                       contentStyle
                   }) {
    return (
        <div className={containerStyle}>
            <span className={contentStyle}>{content || ''}</span>
        </div>
    );
}

export default TableCell;
